module.exports = __webpack_public_path__ + "img/support5.c7d73721.jpg";